import React, { useState } from "react";
import {
	Modal,
	Box,
	Typography,
	TextField,
	Button,
	CircularProgress,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DropDownValue from "../../baseComponents/dropdownvalue";

interface AddCallerDIDModalProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (caller_dids: string[]) => void;
}

const modalStyle = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	borderRadius: 2,
};

const AddCallerDIDModal: React.FC<AddCallerDIDModalProps> = ({ open, onClose, onSubmit }) => {
	// Form State
	const [callerDids, setCallerDids] = useState<string>("");

	const [loading, setLoading] = useState<boolean>(false);

	const handleClose = () => {
		setCallerDids("");
		onClose();
	};

	const handleSubmit = () => {
		setLoading(true);

		let caller_dids: string[] = callerDids.split(",");

		let invalid_caller_dids: string[] = caller_dids.filter((caller_did) => caller_did.length != 10);

		if (invalid_caller_dids.length === 0) {
			onSubmit(caller_dids)
		} else {
			alert("Invalid Caller DID");
		}
		setLoading(false);
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box sx={modalStyle}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
					<Typography variant="h6">Add New Caller DIDs</Typography>
					<IconButton onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Box>

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
					<TextField
						margin='normal'
						type="text"
						label="Caller DID"
						value={callerDids}
						onChange={(event) => setCallerDids(event?.target.value)}
						fullWidth
						multiline
						rows={3}
						slotProps={{
							htmlInput: {
								maxLength: 1000,
							},
						}}
					/>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button onClick={handleClose} sx={{ mr: 2 }}>Cancel</Button>
						<Box mt={2} textAlign="right">
							<Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
								{loading ? <CircularProgress size={24} /> : "Add Caller DIDs"}
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};

export default AddCallerDIDModal;